import { AxiosInstance } from "axios"

export interface StripeOnboardRequest {
  /** ISO 3166-1 alpha-2 code of the country the payout account is created in.
   *  Immutable once the Stripe Connect account exists. */
  countryCode: string
}

export interface StripeOnboardResponse {
  apiStatus: string
  data: {
    stripeAccountId: string
    onboardingUrl: string
    expiresAt: string
  }
}

export function stripeOnboardApi(
  params: StripeOnboardRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: "/agent/stripe/onboard",
    params,
  }) as Promise<{ data: StripeOnboardResponse }>
}
